export default __webpack_public_path__ + "media/images/banner/banner-33-06cef4ac19c2f0df43d095a85668bde8.jpg";